module.exports = __webpack_public_path__ + "7a9162106a5dbc08544280c02495db25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/3/Assets/pizza.jpg
// module id = 1335
// module chunks = 0